/**
 * Zenvoya's own tenants, mirrored from app-backend `src/utils/constants/houseTenant.ts`.
 *
 * Fixed numbers, not configuration: the backend reserves them against minting,
 * so the same codes hold in every environment.
 *
 *   ZENVOYA_ROOT  1000001 → branch 1000011  (the platform tenant; Zenvoya's B2B side)
 *   ZENVOYA_B2C   1000002 → branch 1000012  (the consumer application's tenant)
 */
export const ZENVOYA_ROOT_PARTNER_CODE = 1000001;
export const ZENVOYA_ROOT_BRANCH_CODE = 1000011;
export const ZENVOYA_B2C_PARTNER_CODE = 1000002;
export const ZENVOYA_B2C_BRANCH_CODE = 1000012;

/**
 * The country Zenvoya's own tenants trade from, as a country NAME (the same
 * form a branch record carries). Sent to the embedded traveller app for the
 * CRM's own-account selection, where no partner record is looked up.
 */
export const HOUSE_TENANT_COUNTRY = 'United States';

/**
 * Which of Zenvoya's own tenants an operator's OWN-ACCOUNT selection acts as,
 * by the Booking-for channel:
 *   - `b2b` → Zenvoya (root)   1000001 / 1000011
 *   - `b2c` → Zenvoya B2C      1000002 / 1000012
 *
 * Returns null for any other channel. `name` is the display name; the partner
 * picker appends "(your own account)".
 */
export const ownHouseTenantFor = (channel) => {
  switch (String(channel || '').toLowerCase()) {
    case 'b2b':
      return {
        partnerCode: ZENVOYA_ROOT_PARTNER_CODE,
        branchCode: ZENVOYA_ROOT_BRANCH_CODE,
        channel: 'b2b',
        name: 'Zenvoya',
      };
    case 'b2c':
      return {
        partnerCode: ZENVOYA_B2C_PARTNER_CODE,
        branchCode: ZENVOYA_B2C_BRANCH_CODE,
        channel: 'b2c',
        name: 'Zenvoya B2C',
      };
    default:
      return null;
  }
};
